.copyButton {
  display: inline-flex;
}
